export default __webpack_public_path__ + "static/media/SIW500H_M3.2b0e87af.webp";